/**
 * Minutes in owner words: "45 min", "1 hour", "1.5 hours", or "1 hr 37 min" off the quarter hour (never rounded).
 * The "length" form goes before "block": "a 1.5-hour BTB block".
 */
export function formatDuration(min: number, form: "amount" | "length" = "amount"): string {
  if (min < 60) return `${min} min`;
  if (min % 15 !== 0) return `${Math.floor(min / 60)} hr ${min % 60} min`;
  const hours = min / 60;
  if (form === "length") return `${hours}-hour`;
  return hours === 1 ? "1 hour" : `${hours} hours`;
}
